export default [
    {
        path: '/quiz/user_answers',
        name: 'QuizAnswers',
        props: true,
        component: () => import('../../../views/quiz_answers/quiz_answers.vue'),
        meta: { 
            requiresAuth: true
        }
    },    
    {
        path: '/quiz_answers_user/:id',
        name: 'QuizAnswersUser',
        props: true,
        component: () => import('../../../views/quiz_answers/quiz_user_answers.vue'),
        meta: { 
            requiresAuth: true
        }
    }, 
]